module.exports = __webpack_public_path__ + "media/images/img-pet-3-d7e8b4c7.jpg";